/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Offer.module.scss";
import Inputs from "../../Inputs";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { connect } from "react-redux";
import {
  listAgencies,
  addPolicyToUser,
  getCurrentOffer,
} from "../../../actions/offer";
import { supportSocketEmit } from "../../../actions/support";
import { getUserInfo } from "../../../actions/amarantFields";
import moment from "moment";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { Divider } from "@mui/material";
import {
  convertCurrency,
  formatMoney,
  getBaseCurrencyBySwitchDate,
  getCurrencySymbol,
  getDisplayCurrencyOrderBySwitchDate,
  inferOfferBaseCurrency,
} from "../../../utils/currency";

const customStyles = {
  dropdownIndicator: (base, state) => ({
    ...base,
    color: "#0083E5", // Custom colour
    transition: "all .2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px dotted pink",
    color: state.isSelected ? "white" : "black",
    backgroundColor: state.isSelected ? "#0083E5" : "white",
    padding: 10,
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: (window.innerWidth / 100) * 20,
    height: 40,
    display: "flex",
    border: "1px solid rgb(165, 164, 164)",
    borderRadius: "7px",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition };
  },
};
const typeKeywords = [
  "go",
  "kasko",
  "health",
  "property",
  "other",
  // "protection",
];

const AddPolicyToUser = ({
  listAgencies,
  agencies,
  getUserInfo,
  user,
  addPolicyToUser,
  supportSocketEmit,
  getCurrentOffer,
}) => {
  const { t } = useTranslation();
  const [instCount, setInstCount] = useState(1);
  const [filesCount, setFilesCount] = useState(1);
  const ticketID = window.location.href.split("/")[4];
  const customerID = window.location.href.split("/")[5];
  const offerID = window.location.href.split("/")[6];
  const [selCompany, setSelCompany] = useState({});
  const [policyType, setPolicyType] = useState("");
  const [manualDiscount, setManualDiscount] = useState(false);
  const [manualInstallments, setManualInstallments] = useState(false);
  const [initialPremiumSet, setInitialPremiumSet] = useState(false);
  const [installmentsDiff, setInstallmentsDiff] = useState(null);
  const [dateErrors, setDateErrors] = useState({});
  const navigate = useNavigate();

  const now = new Date();
  const policyBaseCurrency = getBaseCurrencyBySwitchDate(now);
  const policyDisplayOrder = getDisplayCurrencyOrderBySwitchDate(now);
  const getSecondaryHint = (amount) => {
    const secondaryCurrency = policyDisplayOrder[1];
    const converted = convertCurrency(amount, policyBaseCurrency, secondaryCurrency);
    if (converted === null) return undefined;
    return `≈ ${formatMoney(converted)} ${getCurrencySymbol(secondaryCurrency)}`;
  };

  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    customerSupport: true,
    customerSupportId: "",
    policyNumber: "",
    insuranceAgency: "",
    policyType: "",
    client: "",
    clientIdentifier: "",
    startDate: "",
    endDate: "",
    coverage: "",
    amount: "",
    originalAmount: "",
    installmentsCount: "",
    installments: [
      {
        date: "",
        price: null,
        paid: true,
      },
    ],
    files: [
      {
        name: "",
        url: "",
      },
    ],
    discount: {
      value: 0,
      isPercent: false,
      description: "",
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "files",
  });

  useEffect(() => {
    setValue("licensePlate", "");
    if ((policyType === "go" || policyType === "kasko") && instCount > 4) {
      setInstCount(4);
      setValue("installmentsCount", "4");
      updateInstallments();
    }
  }, [policyType]);

  useEffect(() => {
    listAgencies({
      onSuccess: (response) => {
        if (offerID.length > 8) {
          getCurrentOffer({
            id: offerID,
            onSuccess: (res) => {
              const offerBaseCurrency = inferOfferBaseCurrency(
                res,
                res?.createdAt ? new Date(res.createdAt) : new Date()
              );
              const toPolicyBase = (amount) => {
                if (amount === null || amount === undefined) return amount;
                if (offerBaseCurrency === policyBaseCurrency) return amount;
                return convertCurrency(amount, offerBaseCurrency, policyBaseCurrency);
              };

              console.log("[Offer][add-policy] getCurrentOffer response", {
                offerId: res?._id,
                hasBgn: Boolean(res?.bgn),
                offerBaseCurrency,
                policyBaseCurrency,
                premium: res?.premium,
                originalPremium: res?.originalPremium,
                insuranceSum: res?.insuranceSum,
                bgnPremium: res?.bgn?.premium,
                bgnOriginalPremium: res?.bgn?.originalPremium,
                bgnInsuranceSum: res?.bgn?.insuranceSum,
              });

              const offerAmounts = res;
              const premium = toPolicyBase(offerAmounts?.premium);
              const originalPremium = toPolicyBase(
                offerAmounts?.originalPremium ?? offerAmounts?.premium
              );
              append({
                name: "",
                url: "",
              });
              setValue("installmentsCount", `${res.installmentsCount}`);
              setInstCount(res.installmentsCount);
              setValue("customerSupportId", customerID);
              setValue("coverage", `${toPolicyBase(offerAmounts?.insuranceSum)}`);
              setValue("amount", `${premium}`);
              setValue("originalAmount", `${originalPremium}`);
              setValue("startDate", moment(res?.startDate?.split("T")[0])._d);
              setValue(
                "endDate",
                moment(res?.startDate).add(1, "years").subtract(1, "days")._d
              );
              setValue("insuranceAgency", res.insuranceCompanyId);
              setSelCompany({
                label: response.filter(
                  (agency) => agency._id === res?.insuranceCompanyId
                )[0]?.name,
                value: res.insuranceCompanyId,
              });
              setValue(
                "insuranceName",
                response.filter(
                  (agency) => agency._id === res?.insuranceCompanyId
                )[0]?.name
              );
              setValue(
                `installments.${0}.price`,
                toPolicyBase(offerAmounts?.installmentOneSum)
              );
              setValue(
                `installments.${0}.date`,
                moment(res?.installmentOneDate?.split("T")?.[0])?._d
              );
              if (offerAmounts?.installmentTwoSum) {
                setValue(
                  `installments.${1}.price`,
                  toPolicyBase(offerAmounts?.installmentTwoSum)
                );
                setValue(
                  `installments.${1}.date`,
                  moment(res?.installmentTwoDate?.split("T")?.[0])?._d
                );
              }
              if (offerAmounts?.installmentThreeSum) {
                setValue(
                  `installments.${2}.price`,
                  toPolicyBase(offerAmounts?.installmentThreeSum)
                );
                setValue(
                  `installments.${2}.date`,
                  moment(res?.installmentThreeDate?.split("T")?.[0])?._d
                );
              }
              if (offerAmounts?.installmentFourSum) {
                setValue(
                  `installments.${3}.price`,
                  toPolicyBase(offerAmounts?.installmentFourSum)
                );
                setValue(
                  `installments.${3}.date`,
                  moment(res?.installmentFourDate?.split("T")?.[0])?._d
                );
              }
              getUserInfo({
                customerSupportId: customerID,
                onSuccess: (res) => {
                  setValue("client", res?.agreement?.fullName);
                  setValue("clientIdentifier", res?.agreement?.PIN);
                },
              });
            },
          });
        }
      },
    });
  }, []);

  // Helper function to calculate percentage discount
  const calculatePercentDiscount = (amount, discount) => {
    if (discount > 0 && amount) {
      return Number((amount * (1 - discount / 100)).toFixed(2));
    }
    return amount;
  };

  // Calculate discounted amount
  const calculateDiscountedAmount = () => {
    const originalAmount = Number(watch("originalAmount") || watch("amount"));
    const discountValue = Number(watch("discount.value") || 0);

    if (discountValue <= 0) return originalAmount;

    // Always calculate as percentage
    return calculatePercentDiscount(originalAmount, discountValue);
  };

  // Calculate and display difference between premium and installments sum
  const calculateInstallmentsDiff = () => {
    const totalAmount = Number(watch("amount"));

    // Don't calculate diff if no premium entered
    if (!totalAmount) {
      setInstallmentsDiff(null);
      return 0;
    }

    let installmentsSum = 0;
    let hasAnyInstallment = false;

    for (let i = 0; i < instCount; i++) {
      const installmentValue = watch(`installments.${i}.price`);
      if (installmentValue) hasAnyInstallment = true;
      installmentsSum += Number(installmentValue || 0);
    }

    // Don't calculate diff if no installments entered
    if (!hasAnyInstallment) {
      setInstallmentsDiff(null);
      return 0;
    }

    const diff = Number((totalAmount - installmentsSum).toFixed(2));
    setInstallmentsDiff(diff);
    return diff;
  };

  // Validate installment date
  const validateInstallmentDate = (index, newDate) => {
    const errors = { ...dateErrors };
    let isValid = true;

    // Check if date is earlier than start date
    const startDate = watch("startDate");
    if (startDate && moment(newDate).isBefore(moment(startDate))) {
      errors[index] = t("offers:dateBeforePolicyStart");
      isValid = false;
    }
    // Check if date is earlier than previous installment date
    else if (index > 0) {
      const prevDate = watch(`installments.${index - 1}.date`);
      if (prevDate && moment(newDate).isBefore(moment(prevDate))) {
        errors[index] = t("offers:dateBeforePrevious");
        isValid = false;
      }
    }
    // Check if date is later than next installment date
    else if (index < instCount - 1) {
      const nextDate = watch(`installments.${index + 1}.date`);
      if (nextDate && moment(newDate).isAfter(moment(nextDate))) {
        errors[index] = t("offers:dateAfterNext");
        isValid = false;
      }
    }
    // Check if date is after policy end date
    else if (
      watch("endDate") &&
      moment(newDate).isAfter(moment(watch("endDate")))
    ) {
      errors[index] = t("offers:dateAfterPolicyEnd");
      isValid = false;
    } else {
      // If all checks pass, clear error for this index
      delete errors[index];
    }

    setDateErrors(errors);
    return isValid;
  };

  // Clear date error for a specific installment
  const clearDateError = (index) => {
    if (dateErrors[index]) {
      const updatedErrors = { ...dateErrors };
      delete updatedErrors[index];
      setDateErrors(updatedErrors);
    }
  };

  // Handle premium change
  const handlePremiumChange = (e) => {
    const premiumValue = Number(e.target.value);
    setValue("amount", premiumValue);

    // Always update installments when premium changes
    setTimeout(() => {
      // Малко закъснение, за да се обнови стойността в state
      const totalAmount = Number(watch("amount"));
      const amountPerInstallment = Number((totalAmount / instCount).toFixed(2));

      let totalDistributed = 0;
      for (let i = 0; i < instCount; i++) {
        if (i === instCount - 1) {
          const lastInstallment = Number(
            (totalAmount - totalDistributed).toFixed(2)
          );
          setValue(`installments.${i}.price`, lastInstallment);
        } else {
          setValue(`installments.${i}.price`, amountPerInstallment);
          totalDistributed += amountPerInstallment;
        }

        // Премахваме автоматичното попълване на дати
      }

      setInitialPremiumSet(true);
      calculateInstallmentsDiff();
    }, 100);
  };

  // Update installments when premium or discount changes
  const updateInstallments = () => {
    if ((policyType === "go" || policyType === "kasko") && instCount > 4) {
      setInstCount(4);
      setValue("installmentsCount", "4");
    }

    const totalAmount = Number(watch("amount"));
    if (!totalAmount) return; // Don't update if amount is 0 or not set

    const amountPerInstallment = Number((totalAmount / instCount).toFixed(2));

    // Reset all installment values to recalculate them
    let totalDistributed = 0;
    for (let i = 0; i < instCount; i++) {
      if (i === instCount - 1) {
        const lastInstallment = Number(
          (totalAmount - totalDistributed).toFixed(2)
        );
        setValue(`installments.${i}.price`, lastInstallment);
      } else {
        setValue(`installments.${i}.price`, amountPerInstallment);
        totalDistributed += amountPerInstallment;
      }

      // Премахваме автоматичното попълване на дати
    }
    calculateInstallmentsDiff();
  };

  const addInstallment = () => {
    // Добавяне на нова вноска
    setValue(`installments.${instCount}`, {
      date: "",
      price: 0,
      paid: false,
    });
    setInstCount(instCount + 1);
    setValue("installmentsCount", String(instCount + 1));
    // Само новата вноска ще получи стойност
    const totalAmount = Number(watch("amount"));
    let currentSum = 0;
    for (let i = 0; i < instCount; i++) {
      currentSum += Number(watch(`installments.${i}.price`) || 0);
    }
    const remainingAmount = totalAmount - currentSum;
    setValue(
      `installments.${instCount}.price`,
      Number(remainingAmount.toFixed(2))
    );
    calculateInstallmentsDiff();
  };

  // Функция за премахване на конкретна вноска
  const removeInstallment = (index) => {
    // Не позволяваме премахване на всички вноски
    if (instCount <= 1) {
      toast.error(t("offers:atLeastOneInstallment"));
      return;
    }

    // Запазваме всички вноски без тази, която трябва да премахнем
    const newInstallments = [];
    for (let i = 0; i < instCount; i++) {
      if (i !== index) {
        newInstallments.push({
          date: watch(`installments.${i}.date`),
          price: watch(`installments.${i}.price`),
          paid: i === 0 ? true : false,
        });
      }
    }

    // Актуализираме стойността на полето installmentsCount
    const newCount = instCount - 1;
    setInstCount(newCount);
    setValue("installmentsCount", String(newCount));

    // Изчистваме всички вноски и добавяме обновените
    for (let i = 0; i < instCount; i++) {
      setValue(`installments.${i}`, null);
    }

    // Добавяме актуализираните вноски
    for (let i = 0; i < newCount; i++) {
      setValue(`installments.${i}`, newInstallments[i]);
    }

    // Преизчисляваме разликата
    calculateInstallmentsDiff();
  };

  // Handle save with validation
  const handleSave = (e) => {
    const diff = calculateInstallmentsDiff();
    if (diff !== 0) {
      toast.error(
        t("offers:installmentsDiffer", {
          diff: Math.abs(diff),
          currency: getCurrencySymbol(policyBaseCurrency),
        })
      );
      return;
    }

    // Check for installment date errors
    const hasDateErrors = Object.keys(dateErrors).length > 0;
    if (hasDateErrors) {
      toast.error(t("offers:fixInstallmentDates"));
      return;
    }

    // Validate that all installment dates are in sequence
    for (let i = 1; i < instCount; i++) {
      const prevDate = watch(`installments.${i - 1}.date`);
      const currentDate = watch(`installments.${i}.date`);

      if (
        prevDate &&
        currentDate &&
        moment(currentDate).isBefore(moment(prevDate))
      ) {
        toast.error(
          t("offers:installmentDateOrder", { n: i + 1, prev: i })
        );
        return;
      }
    }

    const discountedAmount = manualDiscount
      ? calculateDiscountedAmount()
      : e.amount;

    const payload = {
      customerSupport: true,
      customerSupportId: customerID,
      licensePlate: e.licensePlate,
      policyNumber: e.policyNumber,
      insuranceAgency: e.insuranceAgency,
      phoneNumber: user?.phoneNumber,
      policyType: e.policyType,
      client: e.client,
      clientIdentifier: e.clientIdentifier,
      startDate: moment(e.startDate).format("DD/MM/YYYY"),
      endDate: moment(e.endDate).format("DD/MM/YYYY"),
      coverage: e.coverage,
      amount: discountedAmount,
      installmentsCount: e.installmentsCount,
      installments: e.installments.map((install, i) => {
        return {
          date: moment(install.date).format("DD/MM/YYYY"),
          price: Number(install.price),
          paid: i === 0 ? true : false,
        };
      }),
      files: e.files,
      onSuccess: (response) => {
        toast.success(t("app:policyAdded"));
        const event = {
          action: "sendMessage",
          payload: {
            ticket: ticketID,
            variant: "policy",
            text: "Вашата полица е добавена в профила:",
            metaData: { _id: response._id },
          },
        };
        supportSocketEmit(event);
        navigate(-1);
      },
    };

    // Add discount information if applicable
    if (manualDiscount && e.discount && e.discount.value > 0) {
      payload.discount = {
        value: Number(e.discount.value),
        isPercent: true,
        description: e.discount.description || "Ръчно добавена отстъпка",
      };

      // Always format as percentage
      payload.discountInfo = `-${e.discount.value}%`;
    }

    if (policyType === "health") {
      delete payload.licensePlate;
      payload.policyInsuredObject = {
        type: "person",
        person: payload.client,
      };
    } else if (policyType === "property") {
      delete payload.licensePlate;
      payload.policyInsuredObject = {
        type: "address",
        address: e.address,
      };
    } else if (policyType === "other") {
      payload.policyInsuredObject = {
        type: "person",
        person: payload.client,
      };
    }

    if (moment(e.endDate).diff(moment(e.startDate), "days") < 2) {
      toast.error(
        t("offers:endDateMin2Days")
      );
      return;
    }

    addPolicyToUser(payload);
  };

  return (
    <div className={styles["amarant-container"]}>
      <div className={styles["upper-info-container"]}>
        <h2 className={styles["title"]}>{t("offers:addPolicyToProfile")}</h2>
        <Inputs.Button
          text={t("save")}
          className="green"
          style={{ marginRight: "1%", width: "130px" }}
          onClick={handleSubmit(handleSave)}
        />
      </div>
      <div
        className={styles["middle-info-container"]}
        style={{ height: "unset" }}
      >
        <h2 className={styles["title"]}>{t("offers:basicInfo")}</h2>
        <div className={styles["main-parameters-container block"]}>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "1%",
            }}
          >
            <Controller
              control={control}
              name={`insuranceAgency`}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <Inputs.Dropdown
                  label={t("offers:insuranceCompany")}
                  optionsArray={agencies?.map((agency) => {
                    return {
                      label: agency?.name,
                      value: agency?._id,
                    };
                  })}
                  compulsory
                  customStyles={customStyles}
                  style={{ width: "22%", height: "100%" }}
                  single
                  addPolicy={true}
                  pair={selCompany}
                  className={error && "failed"}
                  onChange={(e) => {
                    setValue("insuranceName", e.label);
                    setValue(`insuranceAgency`, e.value);
                    setSelCompany({
                      label: e.label,
                      value: e.value,
                    });
                  }}
                />
              )}
              rules={{ required: true }}
            />
            <Controller
              control={control}
              name={"startDate"}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <Inputs.DatePicker
                  label={t("offers:startDate")}
                  compulsory
                  custom
                  style={{ width: "12%", height: "100%", marginLeft: "4%" }}
                  value={value}
                  onChange={(e) => {
                    setValue("startDate", e);
                    setValue(
                      "endDate",
                      moment(e).add(1, "year").subtract(1, "day")?._d
                    );
                  }}
                  className={error && "failed"}
                />
              )}
              rules={{ required: true }}
            />
            <Controller
              control={control}
              name={"endDate"}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <Inputs.DatePicker
                  label={t("offers:endDate")}
                  compulsory
                  custom
                  style={{ width: "12%", height: "100%", marginLeft: "2%" }}
                  value={value}
                  onChange={(e) => {
                    setValue("endDate", e);
                  }}
                  className={error && "failed"}
                />
              )}
              rules={{ required: true }}
            />
            <Controller
              control={control}
              name={"installmentsCount"}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <div style={{ margin: "0% 3%", width: "20%" }}>
                  <label>{t("offers:installmentCount")}</label>
                  <div
                    style={{
                      display: "flex",
                      marginTop: "5px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Inputs.Button
                      text={1}
                      selected={value === "1"}
                      style={{ marginRight: "3%" }}
                      onClick={() => {
                        setValue("installmentsCount", "1");
                        setInstCount(1);
                        updateInstallments();
                      }}
                    />
                    <Inputs.Button
                      text={2}
                      selected={value === "2"}
                      style={{ marginRight: "3%" }}
                      onClick={() => {
                        setValue("installmentsCount", "2");
                        setInstCount(2);
                        updateInstallments();
                      }}
                    />
                    <Inputs.Button
                      text={3}
                      selected={value === "3"}
                      style={{ marginRight: "3%" }}
                      onClick={() => {
                        setValue("installmentsCount", "3");
                        setInstCount(3);
                        updateInstallments();
                      }}
                    />
                    <Inputs.Button
                      text={4}
                      selected={value === "4"}
                      style={{ marginRight: "3%" }}
                      onClick={() => {
                        setValue("installmentsCount", "4");
                        setInstCount(4);
                        updateInstallments();
                      }}
                    />
                    {policyType !== "go" && policyType !== "kasko" && (
                      <Inputs.Button
                        text="+"
                        style={{ marginRight: "3%" }}
                        title={t("offers:addUnlimitedInstallments")}
                        onClick={() => {
                          addInstallment();
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
              rules={{ required: true }}
            />
            <div style={{ width: "18%", marginRight: "2%" }}>
              <Inputs.TextInput
                label={t("offers:insuranceSum")}
                suffix={getCurrencySymbol(policyBaseCurrency)}
                style={{ width: "100%" }}
                className={errors.coverage ? "failed" : ""}
                {...register(`coverage`)}
              />
              {getSecondaryHint(watch("coverage")) && (
                <div className={styles["currency-hint"]}>
                  {getSecondaryHint(watch("coverage"))}
                </div>
              )}
            </div>
            <div
              style={{ display: "flex", alignItems: "flex-end", width: "40%" }}
            >
              <div style={{ width: "25%", marginRight: "2%" }}>
                <Inputs.TextInput
                  label={t("offers:premium")}
                  compulsory
                  suffix={getCurrencySymbol(policyBaseCurrency)}
                  type="number"
                  style={{ width: "100%" }}
                  className={errors.amount ? "failed" : ""}
                  {...register(`amount`, {
                    required: true,
                    onChange: handlePremiumChange,
                  })}
                />
                {getSecondaryHint(watch("amount")) && (
                  <div className={styles["currency-hint"]}>
                    {getSecondaryHint(watch("amount"))}
                  </div>
                )}
              </div>

              {/* Toggle for manual discount */}
              {/* <div
                className="input-container"
                style={{ width: "8%", marginRight: "10px" }}
              >
                <label
                  style={{
                    display: "flex",
                    width: "100%",
                    fontSize: "0.8rem",
                    marginBottom: "5px",
                  }}
                >
                  {t("offers:addDiscount")}
                </label>
                <Inputs.Button
                  text={manualDiscount ? t("offers:on") : t("offers:off")}
                  selected={manualDiscount}
                  onClick={() => {
                    setManualDiscount(!manualDiscount);
                    if (!manualDiscount) {
                      // Initialize discount structure
                      const currentAmount = watch("amount");
                      setValue("originalAmount", currentAmount);
                      setValue("discount.value", 0);
                      // Always set isPercent to true
                      setValue("discount.isPercent", true);
                    } else {
                      setValue("discount.value", 0);
                    }
                    updateInstallments();
                  }}
                />
              </div> */}
            </div>
          </div>

          {/* Discount controls */}
          {/* {manualDiscount && (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                marginTop: "1%",
              }}
            >
              <Inputs.TextInput
                label={t("offers:discount")}
                suffix={"%"}
                type="number"
                style={{ width: "15%", marginRight: "2%" }}
                {...register("discount.value", {
                  onChange: () => {
                    // Set isPercent to true when changing the value
                    setValue("discount.isPercent", true);
                    updateInstallments();
                  },
                })}
              />

              <Inputs.TextInput
                label={t("offers:discountDescription")}
                style={{ width: "40%", marginRight: "2%" }}
                {...register("discount.description")}
              />

                <Inputs.TextInput
                  label={t("offers:premiumWithDiscount")}
                  suffix={getCurrencySymbol(policyBaseCurrency)}
                disabled
                value={calculateDiscountedAmount().toFixed(2)}
                style={{ width: "15%", marginRight: "2%" }}
              />
            </div>
          )} */}

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "1%",
            }}
          >
            <Controller
              control={control}
              name={`policyType`}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <Inputs.Dropdown
                  label={t("offers:kind")}
                  optionsArray={typeKeywords?.map((type) => {
                    return {
                      label: type,
                      value: type,
                    };
                  })}
                  compulsory
                  customStyles={customStyles}
                  style={{ width: "20%", height: "100%" }}
                  single
                  value={value}
                  className={error && "failed"}
                  onChange={(e) => {
                    setValue(`policyType`, e.value);
                    setPolicyType(e.value);
                  }}
                />
              )}
              rules={{ required: true }}
            />
            <Inputs.TextInput
              label={t("offers:policyNumber")}
              compulsory
              style={{ width: "12%", marginRight: "1%" }}
              className={errors.policyNumber ? "failed" : ""}
              {...register(`policyNumber`, {
                required: true,
              })}
            />
            {policyType === "property" ? (
              <Inputs.TextInput
                label={t("offers:address")}
                compulsory
                style={{ width: "20%", marginRight: "1%" }}
                className={errors.address ? "failed" : ""}
                {...register(`address`, {
                  required: true,
                })}
              />
            ) : policyType === "health" ||
              policyType === "property" ||
              policyType === "other" ? null : (
              <Inputs.TextInput
                label={t("offers:plateLatin")}
                compulsory={policyType !== "other"}
                style={{ width: "12%", marginRight: "1%" }}
                className={errors.licensePlate ? "failed" : ""}
                {...register(`licensePlate`, {
                  required: policyType === "other" ? false : true,
                  pattern: /^[a-z0-9]+$/i,
                })}
              />
            )}

            <Inputs.TextInput
              label={t("offers:insured")}
              compulsory
              style={{ width: "25%", marginRight: "1%" }}
              className={errors.client ? "failed" : ""}
              {...register(`client`, {
                required: true,
              })}
            />
            <Inputs.TextInput
              label={t("offers:egn")}
              compulsory
              style={{ width: "12%", marginRight: "1%" }}
              className={errors.clientIdentifier ? "failed" : ""}
              {...register(`clientIdentifier`, {
                required: true,
              })}
            />
          </div>
        </div>
      </div>
      <div
        className={styles["middle-info-container"]}
        style={{ height: "unset" }}
      >
        <h2 className={styles["title"]}>{t("offers:installments")}</h2>
        <div className={styles["main-parameters-container"]}>
          {Array(instCount)
            .fill("")
            .map((el, i) => {
              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                    marginBottom: "15px",
                    position: "relative",
                  }}
                >
                  <div style={{ width: "200px", marginRight: "20px" }}>
                    <label
                      style={{
                        display: "block",
                        fontSize: "0.8rem",
                        marginBottom: "5px",
                        whiteSpace: "nowrap",
                        height: "16px",
                      }}
                    >
                      {t("offers:installmentNAmount", { n: i + 1 })}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Inputs.TextInput
                      compulsory={false}
                      suffix={getCurrencySymbol(policyBaseCurrency)}
                      style={{
                        width: "100%",
                        height: "40px",
                        borderColor:
                          installmentsDiff !== null && installmentsDiff !== 0
                            ? "#ff9800"
                            : undefined,
                      }}
                      className={errors.coverage ? "failed" : ""}
                      {...register(`installments.${i}.price`, {
                        required: true,
                        onChange: () => {
                          if (initialPremiumSet) {
                            calculateInstallmentsDiff();
                          }
                        },
                      })}
                    />
                    {getSecondaryHint(watch(`installments.${i}.price`)) && (
                      <div className={styles["currency-hint"]}>
                        {getSecondaryHint(watch(`installments.${i}.price`))}
                      </div>
                    )}
                  </div>

                  <div style={{ width: "200px" }}>
                    <label
                      style={{
                        display: "block",
                        fontSize: "0.8rem",
                        marginBottom: "5px",
                        whiteSpace: "nowrap",
                        height: "16px",
                      }}
                    >
                      {t("offers:installmentNDate", { n: i + 1 })}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Controller
                      control={control}
                      name={`installments.${i}.date`}
                      render={({
                        field: { value, onChange },
                        fieldState: { error },
                      }) => (
                        <div style={{ position: "relative" }}>
                          <Inputs.DatePicker
                            compulsory={false}
                            custom
                            style={{
                              width: "100%",
                              height: "40px",
                              borderColor: dateErrors[i] ? "red" : undefined,
                            }}
                            value={value}
                            minDate={
                              i > 0
                                ? watch(`installments.${i - 1}.date`)
                                : watch("startDate")
                            }
                            onChange={(e) => {
                              onChange(e);
                              if (e) {
                                validateInstallmentDate(i, e);
                              } else {
                                // Clear error when date is cleared
                                clearDateError(i);
                              }
                            }}
                            className={error && "failed"}
                          />
                          {dateErrors[i] && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "0.7rem",
                                position: "absolute",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {dateErrors[i]}
                            </div>
                          )}
                        </div>
                      )}
                      rules={{ required: true }}
                    />
                  </div>

                  {/* Бутон за премахване на вноска */}
                  <div style={{ marginLeft: "10px", marginTop: "25px" }}>
                    <Inputs.Button
                      text={t("delete")}
                      className="red"
                      style={{
                        padding: "5px 10px",
                        minWidth: "70px",
                        fontSize: "0.8rem",
                      }}
                      onClick={() => removeInstallment(i)}
                    />
                  </div>

                  {i === instCount - 1 &&
                    installmentsDiff !== null &&
                    installmentsDiff !== 0 && (
                      <div
                        style={{
                          color: "#ff9800",
                          fontSize: "0.8rem",
                          marginLeft: "20px",
                          whiteSpace: "nowrap",
                          position: "absolute",
                          left: "500px",
                          top: "40px",
                        }}
                      >
                        {installmentsDiff > 0
                          ? t("offers:leftToAllocate", {
                              amount: installmentsDiff,
                            })
                          : t("offers:exceedsPremium", {
                              amount: Math.abs(installmentsDiff),
                            })}
                      </div>
                    )}
                </div>
              );
            })}
        </div>
      </div>

      <div
        className={styles["middle-info-container"]}
        style={{ height: "unset", overflowY: "auto" }}
      >
        <h2 className={styles["title"]}>{t("offers:policyDocuments")}</h2>
        <div className={styles["main-parameters-container block"]}>
          {fields.map((el, i) => {
            return (
              <div
                style={{
                  display: "flex",
                  margin: "2% 0%",
                  alignItems: "center",
                }}
                key={el.id}
              >
                {fields?.length > 1 && (
                  <div
                    className="close-icon"
                    style={{ marginRight: "2%" }}
                    onClick={() => remove(i)}
                  />
                )}
                <Inputs.TextInput
                  label={t("offers:documentName")}
                  compulsory
                  key={el.id}
                  style={{ width: "40%", marginRight: "1%" }}
                  className={errors?.files?.[i]?.name ? "failed" : ""}
                  {...register(`files.${i}.name`, {
                    required: true,
                  })}
                />
                <Controller
                  control={control}
                  name={`files.${i}.url`}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <Inputs.ImageInput
                        label={t("offers:document")}
                        compulsory
                        style={{ width: "25%", margin: "10px 0px" }}
                        value={value}
                        specialDir={true}
                        info={{
                          keyword: "policy",
                          id: ticketID,
                          date: moment().format("DD.MM.YYYY"),
                        }}
                        key={"documents"}
                        onChange={(e) => setValue(`files.${i}.url`, e)}
                        setValue={setValue}
                        className={error && "failed"}
                      />
                    </>
                  )}
                  rules={{ required: true }}
                />
              </div>
            );
          })}
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <Inputs.Button
              text={t("offers:addNew")}
              style={{ width: "10%" }}
              className="dotted"
              onClick={() => {
                append({
                  name: "",
                  url: "",
                });
                setFilesCount(filesCount + 1);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  agencies: state.offer.agencies,
  getUserInfo: state.amarantFields?.getUserInfo || null,
  user: state.user?.user || null,
  addPolicyToUser: state.offer.addPolicyToUser,
  supportSocketEmit: state.support.supportSocketEmit,
  getCurrentOffer: state.offer.getCurrentOffer,
});

const mapDispatchToProps = (dispatch) => ({
  listAgencies: (payload) => dispatch(listAgencies(payload)),
  addPolicyToUser: (payload) => dispatch(addPolicyToUser(payload)),
  supportSocketEmit: (payload) => dispatch(supportSocketEmit(payload)),
  getUserInfo: (payload) => dispatch(getUserInfo(payload)),
  getCurrentOffer: (payload) => dispatch(getCurrentOffer(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPolicyToUser);
